module.exports = __webpack_public_path__ + "img/luckbg.ed7dfdac.png";